<template>
  <div class="div_flex">
    <Nav/>
    <img style="width: 100%" src="../../assets/images/公司概况.png" alt=""/>
    <div class="container">
      <div
          style="
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
        "
      >
        <div style="padding-bottom: 10px">
          <div class="container_n">
            <img
                style="width: 18px; margin-right: 5px"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABMBJREFUWEftmFtsFHUUxr8zM22tVIgxJqDp7hYbCLWRGFO04gWECglpsGx3lniJO6UagiFqovGNrrwao+FBk95mjcZkZ8tyk0qN2KCBNJoGoxGrEbo7BVEoUrW2pbudY6ZYUunMzsx2TXjw/zrf+c5vzv92Zgg3+KAbnA//A853hvKuYDTKQuxschUbRr1hGA+B6A4wLyEig5nPE+EcWDhGJBxKdW45SUScD6xnwJCmiX1H8AwZ3MJAwE1SAg0AtCutNnZ5BfUEeNe2ZHXGyMaZucoN2BwN4SsiaaveGTzjNt41oD+S2GIQvwfmMrfmljqi30ggWe8IHXXj4wrQ36Q1GAb2AuxK75SYCBkBVJdS5WOOWidBRVNyZdbIHAewwEnr6TlhWBBpVbpdHswVl7Mia6K90unUhe8ALMudnJiIT4IxyDS9DZYysNJFxfuGYuHavAHLm+LbYeBdOwMCTTLRHrGU30y9I/8yW7dsu3bnxBW8ysALYJbsPAQIwXQslLTPYfPErN6Z1EWdwUusFzuGBQib02roRK4KBJoTa4yskWTgVisdEb7X1bDtqWA7xX5Fe8xgttxp5iKHIK3VO4Lm2nQcvm2JdTzFPQCLVmKxiO5NtclfW76AnbsvEn+LgZes31rYo6uhFx3JZgl8kUQrw3jO2o9adFXe7QmwXNH6wHy/VZAkSoHBjmDaC6C/ObnCyGZO2QB+pqvyOm+AES0NsO/6IPPa0mPyCi9wM9pyG08APw7Fwss9AfoUbYKZS+YEEXqG1PDG/ADj5sH8iEXsX0OxsOUNZbtJyiPaMMC3WVTwqB6T1+cD6FO048z84BxPoj91VV7oqYLlSvxbMKrnAiKlx8IVeQFGtPMMXmzheVqPhSu9AUbi+wA8YRlUJFbrbY3mDeN6LI3srckg+6XNJvlCV2Wrqbdv+f1Kotlgo82SgOjDIVV+yjUdgHJFS4K5wQZwt67KLZ4qGNihLZ4aw8/W96l590LWVbnLDaRPiT/NjPfttKIk1abag32eAE2xLxL/gAGbStE4CMqQKsdzQfqU+LNgamVwsU31fmjyh6qiUTI8A/qbtQrOYsDO/B/D/QIJbyj+xr6ZJOb3SkeqazWBX2PwppxVJtqa6yUdG1Cfou1i5tedppKAy0zQMd1vwc/Mi5xjqD+thmpyfac4AjIz+RUtwUDQKaG353RJkFAzr4Z1JuE9r/QsuDw88imAB7xBWKvNbohI2pDuDPY6+TlWcMagcmf3wsnR0SPMnLMDdkoI0LggIpTukA87a+Ht18fypgO3jBsTHzOw2o359RoC/hBFqX6wI/i523jXFZwxrNqhlY2Oo5uZH3abZFpHGCaRNurtcr+XOM+Apvn0mrz0+2EwP+oqGdFZsUioS7U2DrjSzxLlBWjG3/f8oZsvZsY+YsZah3PuJ0kQ13ttcGc88wa8Bjk5fpDBlt0wQN9IUsnjg+2bf/VauYIAmia1L2ul50ZwgJnrZkMQ0QlhUdGm1NsNI/nCXV26BRiBaO9NU+kL+8HYcNWUPrm9uLShv7V+bL72BQE0ISp3dpdcGR3dR8xjZQF68lRUnpwvXMEqeO0IimrFd1dhKiHLU4WAKzhgoaD+tZb/C9NCev4Nr8bDONbHMf4AAAAASUVORK5CYII="
                alt=""
            />
            <div>您的位置：</div>
            <el-breadcrumb separator="/" class="top">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>公司概况</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="logo">
          <div class="nav-items">
            <div
                v-for="(item, i) in navList"
                :key="i"
                @click="toDetail(i)"
                :class="['nav-item', { active: tabIndex === i }]"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <el-card v-if="tabIndex == 0" class="top">
        <div class="content">
          <div class="qqqqqqqqqq">
            <div class="left_list">
              <div style="color: #9a9fa5; margin-bottom: 5px">成立于2024年</div>
              <div style="color: #000">南京玖禧猫珠宝有限公司</div>
            </div>
          </div>
          <div class="tent">
            <div class="tnet_title">南京玖禧猫珠宝有限公司</div>
            <div class="tent_tent">
              <p>
                玖禧猫珠宝，专注贵金属综合服务，以专业、安全、透明为核心，为客户提供一站式贵金属解决方案。
              </p>
              <p>
                我们配备德国赛多利斯高精度天平、JPSPEC专业测金仪等先进设备，建立标准化检测体系，称重精度可达0.001克。坚守不压价、不融金、不过酸的服务承诺，全程支持第三方权威机构复检。
              </p>
              <p>
                团队由持有彩色宝石鉴定师、贵金属检测师等专业资质人员组成，搭配自主研发管理系统，实现全流程可视化、透明化服务。
              </p>
              <p>
                采用线上+线下实体门店双模式运营，线上便捷操作，线下备案门店安心交付，真正做到高效便捷与安全可靠兼顾。
              </p>

              <!--              <img src="../../assets/images/Snipaste.png" alt="" />-->
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <Footer class="top"/>
  </div>
</template>

<script>
import Banner from "./components/Banner";
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import {getAboutById} from "@/api/index.js";

export default {
  name: "About",
  components: {Nav, Footer, Banner},

  data() {
    return {
      tabIndex: 0,
      imageUrl: "",
      navList: [
        {
          name: "公司简介",
        }
      ],
    };
  },

  mounted() {
    console.log(11);

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }, 0)
  },

  methods: {
    toDetail(i) {
      this.tabIndex = i;
    },
    fetchAboutImage() {
      getAboutById(1)
          .then((response) => {
            this.imageUrl = response.data.imageUrl; // 假设返回的数据中包含 imageUrl 字段
          })
          .catch((error) => {
            console.error("API request failed:", error);
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.div_flex {
  background: url(../../assets/images/底部纹理.png) no-repeat;
  background-position: 0 500px;
}

.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh; // Ensure the page takes at least the full height of the viewport
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
}

.container {
  flex: 1; // Allow the container to grow and fill available space
  margin-bottom: 100px; // Add space between container and footer
  .container_n {
    font-size: 14px;
    display: flex;
    align-items: flex-end;
  }
}

.about-us {
  margin: 40px 0;
  text-align: center;

  h2 {
    font-size: 24px;
    margin-bottom: 20px;
    position: relative;
  }

  h2::after {
    content: "";
    display: block;
    width: 50px;
    height: 2px;
    background: red;
    margin: 10px auto 0;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
  }
}

/* 新增样式 */
.about-image {
  width: 100%;
  height: auto;
  border: 1px solid #e1e1e1;
}

.content {
  font-size: 24px;
  display: flex;

  .content_guanjia {
    flex: 0 0 330px;
    margin-right: 20px;
    border-right: 1px solid #000;
    font-weight: 700;
  }

  .qqqqqqqqqq {
    flex: 0 0 350px;
  }

  .left_list {
    margin-right: 20px;
    padding: 15px;
    background-color: #f3f5f7;
  }

  .tent {
    width: 100%;

    .tnet_title {
      color: #151f2f;
      font-weight: 700;
      font-size: 24px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e5e5e5;
    }

    .tent_tent {
      p {
        font-size: 16px !important;
        color: #454a5b;
        text-indent: 2em;
        margin: 2em 0 2em 0;
        line-height: 30px;
      }
    }
  }
}

.logo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1; // 让 logo 部分占据剩余空间

  .nav-items {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    &::-webkit-scrollbar {
      display: none; /* WebKit */
    }
  }
}

.nav-item {
  flex: 0 0 auto;
  padding: 0 15px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.3s;

  &:hover,
  &.active {
    color: #4c88ff;
  }
}

.active {
  color: #0b2183;
  border-bottom: 3px solid #0b2183;
}
</style>